import { useNavigate, useParams, useSearch } from '@tanstack/react-router'
import { useEffect } from 'react'

import { benmoInviteCode } from '../consts'
import { refCodesV2 } from '@/features/actions/logic/useIntegratorRefCode'

export function useAppendBenmoRefCode(): void {
  const { referralCode } = useParams({ from: '/points/{-$referralCode}' })
  const search = useSearch({ strict: false })
  const navigate = useNavigate()

  useEffect(() => {
    if (referralCode === benmoInviteCode) {
      if (search.ref_code === refCodesV2.benmo) {
        return
      }
      void navigate({
        to: '.',
        search: { ...search, ref_code: refCodesV2.benmo },
        replace: true,
      })
    }
  }, [referralCode, search, navigate])
}
